module.exports = __webpack_public_path__ + "img/cctvinspection_parked.da170d84.svg";